import React from "react";
import BackButton from "../BackButton/BackButton";
import { Typography } from "@material-ui/core";

const PageHeader = ({ hasBack = true, title, onBack }) => {
  return (
    <div className="flex items-center gap-6">
      {hasBack ? <BackButton onClick={onBack} /> : null}
      <Typography
        style={{ fontSize: "20px", display: "inlineblock" }}
        variant="subtitle2"
      >
        {title}
      </Typography>
    </div>
  );
};

export default PageHeader;
